/**
 * Click Outside Directive
 * For container that should be hidden on click outside
 */
import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  OnDestroy,
  OnInit,
  Injector,
} from '@angular/core';
import { BaseComponent } from '@app/components/base-component';

@Directive({
  selector: '[clickOutside]',
  standalone: false,
})
export class ClickOutsideDirective
  extends BaseComponent
  implements OnDestroy, OnInit
{
  @Output() public clickOutside: EventEmitter<Event> =
    new EventEmitter<Event>();
  @Input() public touchendAsClick: boolean = false;
  @Input() public isModal: boolean;

  public enableSystemLoader = false;

  private callbacks = {
    main: this.onClick.bind(this),
  };
  private outerContainer: Element;

  public constructor(
    injector: Injector,
    private el: ElementRef,
  ) {
    super(injector);
  }

  public ngOnInit(): void {
    if (!this.isModal) {
      this.outerContainer = document.getElementsByTagName('main')[0];
    } else {
      this.outerContainer = this.el.nativeElement.closest('modal');
    }
    if (this.outerContainer) {
      this.outerContainer.addEventListener('click', this.callbacks.main);
      if (this.touchendAsClick) {
        this.outerContainer.addEventListener('touchend', this.callbacks.main);
      }
    }
  }

  public ngOnDestroy(): void {
    if (this.outerContainer) {
      this.outerContainer.removeEventListener('click', this.callbacks.main);
      if (this.touchendAsClick) {
        this.outerContainer.removeEventListener(
          'touchend',
          this.callbacks.main,
        );
      }
    }
  }

  public onClick(event: Event): void {
    if (this.enableSystemLoader) {
      return;
    }

    const target: Element = <Element>event.target;
    const isClickInside: boolean = this.el.nativeElement.contains(target);

    if (isClickInside) {
      return;
    }

    const scrollTargetParent: Element | null = target?.parentElement;

    if (
      scrollTargetParent &&
      (scrollTargetParent.classList.contains('scroll-btn-group') ||
        scrollTargetParent.parentElement?.classList.contains(
          'scroll-btn-group',
        ))
    ) {
      return;
    }

    this.clickOutside.emit(event);
  }
}
